<!--suppress JSUnfilteredForInLoop -->
<template>
    <validation-observer slim v-slot="{}" ref="formValidator">
        <form role="form" @submit.prevent="performSubmit()" key="formPage">
            <slot></slot>
        </form>
    </validation-observer>
</template>

<script>
import BaseForm from './BaseForm';

export default {
    name    : 'base-form',
    extends : BaseForm,
    props   : {},
    data () {
        return {};
    },
    methods : {
        async performSubmit () {
            const validator = this.$refs.formValidator;
            const result = await validator.validate();
            if (result) {
                this.$emit('submit');
            } else {
                this.$emit('submitError');
            }
        },

        reset () {
            this.$refs.formValidator.reset();
        }
    }
};
</script>
